import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

import { Link } from 'core/routing';

export const SideNavBarWrapper = styled.div`
  float: left;
  margin-bottom: ${props => props.theme.spacing.default};
  position: sticky;
  top: 95px;
  overflow: hidden;
  ${media.l`
    width: calc(15% - 10px);
  `};
  ${media.m`
    width: 100%;
    position: relative;
    top: 0;
    margin-bottom: 0;
  `};
`;

export const SettingsWrapper = styled.div`
  width: calc(88% - 10px);
  float: right;
  margin-top: 8px;
  margin-bottom: 60px;
  height: auto;
  min-width: 625px;
  ${media.l`
    width: calc(85% - 10px);
  `};
  ${media.m`
    width: 100%;
    float: none;
    display: flex;
    margin-top: 2rem;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: 625px;
  `};
`;

export const SideNavBar = styled.ul`
  overflow: hidden;
  position: ${props => (props.shouldFixed ? 'fixed' : 'static')};
  left: ${props => (props.shouldShowFrameSideBar ? '350px' : '50px')};
`;

export const SideNavBarItem = styled.li`
  font-size: ${props => (props.isTitle ? '1.25rem' : '0.925em')};
  font-weight: ${props =>
    props.isTitle
      ? props.theme.font.weight.xbold
      : props.theme.font.weight.regular};
  color: ${props => props.theme.color.wfBlack};
  padding: ${props =>
    props.isTitle ? '0px 10px 20px 0px' : '0px 10px 8px 0px'};
  line-height: 1.55;
  > a {
    color: ${props => props.theme.color.primary};
    font-weight: 600;
  }
`;

export const SideNavBarLink = styled(Link)`
  font-weight: ${props => props.theme.font.weight.regular} !important;
  color: ${props => props.theme.color.wfBlack} !important;
  border-left: ${props =>
    props.active ? `3px solid ${props.theme.color.primary}` : 'none'};
  padding: 8px 10px;
  display: block;
  &:hover {
    text-decoration: none !important;
    color: ${props => props.theme.color.primary} !important;
  }
`;
